/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from "@angular/core";

export interface ISelectCategoryFacade {
    selectManageMode(): any;
    getElectricalState(): any;
}

export const SELECT_CATEGORY_FACADE_TOKEN = new InjectionToken<ISelectCategoryFacade>('SELECT_CATEGORY_FACADE_TOKEN');